module.exports = __webpack_public_path__ + "static/media/sales.013cfb16.png";